import { Pixall } from 'reaxl-analytics-handlers';

/**
 * @summary Sends an impression event for Hyundai Buy Online articles.
 * @events event1
 */
export function hyundaiBuyOnlineArticlesImpression({ dataLayer }, option) {
    Pixall.sendImpression({ dataLayer }, {
        eventSource: 'vehicle',
        eventType: 'impression',
        label: 'article-carousel',
        listingType: 'article',
        feature: 'article',
    }, option);

    return {};
}

/**
 * @summary Sends Pixall analytic data for Hyundai Buy Online articles click.
 * @events event2
 */
export function hyundaiBuyOnlineArticleClick({ data = {}, dataLayer }, option) {
    const { pixallData } = data;
    const sanitizeValue = (value) => value.replace(/\s+/g, '-').replace(/_+/g, '-').replace(/[!@#$%^&*,]/g, '').toLowerCase();

    pixallData.label = `cta_article-carousel_${sanitizeValue(pixallData?.category)}`;
    delete pixallData.category;

    Pixall.sendClickEvent({
        eventSource: 'vehicle',
        eventType: 'click',
        feature: 'article',
        listingType: 'article',
        ...pixallData,
    }, dataLayer, option);

    return {};
}
